"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var shortcut_plugin_1 = require("./shortcut-plugin");
function blockLeafShortcut(regexp, name, config) {
    return new shortcut_plugin_1.TextShortcut(name, regexp, function (view, state, match, start, end) {
        var nodeType = state.schema.nodes[name];
        if (!nodeType)
            return null;
        var attrs = shortcut_plugin_1.getShortcutAttrs(config.handler, view, match, start, end);
        if (!attrs)
            return null;
        var $pos = state.doc.resolve(start);
        var newNode = nodeType.create(attrs);
        return state.tr.replaceWith($pos.before(), $pos.after(), newNode);
    }, config);
}
exports.blockLeafShortcut = blockLeafShortcut;
//# sourceMappingURL=block-leaf-shortcut.js.map